@if (layoutService.showAdminLayout$ | async) {
  @if (layoutService.sidebarOpen) {
    <div class="admin-backdrop d-lg-none"
    (click)="layoutService.closeSidebar()"></div>
  }
  <admin-sidebar></admin-sidebar>
}

<div [class.admin-shell]="layoutService.showAdminLayout$ | async">
  @if (layoutService.showAdminLayout$ | async) {
    <admin-header></admin-header>
  }
  <main [class.admin-main]="layoutService.showAdminLayout$ | async">
    <div id="mainContent">
      <router-outlet></router-outlet>
    </div>
  </main>
  @if (layoutService.showAdminLayout$ | async) {
    <footer class="admin-footer border-top text-center text-secondary py-4">
      <span>Konsumentverket</span>
    </footer>
  }
</div>
